import * as Sentry from '@sentry/react';
import { userIdStorage } from '@/utils/storage';

class Logger {
  get roomID() {
    const pathname = window.location.pathname;
    const splittedPath = pathname.split('/');

    return splittedPath[splittedPath.length - 1];
  }

  setUser(params: Sentry.User) {
    Sentry.setUser(params);
  };

  event(name: string, data?: object) {
    const enrichedData = {
      ...(data || {}),
      roomID: this.roomID,
      userId: userIdStorage.getItem(),
    };

    Sentry.addBreadcrumb({
      category: 'custom.event',
      message: name,
      data: enrichedData,
      level: 'info'
    });
  }

  error(error?: unknown, params?: Record<string, unknown>) {
    console.warn('Error: - ', error);

    const enrichedData = {
      ...(params || {}),
      roomID: this.roomID,
      userId: userIdStorage.getItem(),
    };

    const wrapped = error instanceof Error
      ? error
      : new Error(
        `Error: \nExtra: ${JSON.stringify(
          error || {},
          null,
          2,
        )}`,
      );

      Sentry.withScope((scope) => {
        scope.setTag('handled', 'true');
        scope.setExtras({
          ...enrichedData,
          roomID: this.roomID
        });
        Sentry.captureException(wrapped);
      });
  }
}

export const logger = new Logger();
